import { motion } from "framer-motion";

/**
 * MaskedReveal
 * Splits `children` (string) into words, wraps each word in an overflow-hidden mask,
 * and reveals with translateY 100% -> 0. Signature on-load moment.
 */
export default function MaskedReveal({
  as: Tag = "span",
  children,
  className = "",
  delay = 0,
  stagger = 0.045,
  duration = 0.9,
  inView = false,
}) {
  const words = String(children).split(" ");
  const parent = {
    hidden: {},
    show: { transition: { staggerChildren: stagger, delayChildren: delay } },
  };
  const child = {
    hidden: { y: "115%" },
    show: {
      y: "0%",
      transition: { duration, ease: [0.76, 0, 0.24, 1] },
    },
  };
  return (
    <Tag className={className}>
      <motion.span
        style={{ display: "inline" }}
        variants={parent}
        initial="hidden"
        whileInView={inView ? "show" : undefined}
        animate={inView ? undefined : "show"}
        viewport={inView ? { once: true, amount: 0.3 } : undefined}
      >
        {words.map((w, i) => (
          <span key={i} className="reveal-mask">
            <motion.span variants={child} style={{ display: "inline-block" }}>
              {w}
              {i < words.length - 1 ? "\u00A0" : ""}
            </motion.span>
          </span>
        ))}
      </motion.span>
    </Tag>
  );
}
